import styled from 'styled-components';
import { rgba } from 'polished';
import { COLOR_RED } from '../../../assets/styles/colors';
import { SmallText } from '../../typography';

export default styled.div`
  .modal-loading-wrap {
    display: flex;
    justify-content: center;
  }
  .top-text-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    h2 {
      max-width: 100%;
    }
  }
  .section-switch-wrap {
    margin-top: 24px;
    button {
      width: 100% !important;
      flex: 1;
    }
  }

  .loan-summary-wrap {
    margin-top: 48px;
    padding: 24px;
    border: 1px solid rgba(47, 46, 65, 0.2);
    border-radius: 12px;

    .divider {
      width: 100%;
      height: 1px;
      background: rgba(47, 46, 65, 0.2);
    }

    &--top {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-bottom: 16px;
      text-align: center;
    }
    &--bottom {
      padding-top: 30px;
      display: flex;
      flex-direction: column;
      &__row {
        padding-bottom: 10px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        &:last-child {
          padding-bottom: 5px;
        }
      }
    }

    &.guarantee_fund {
      margin-top: 0;
    }
  }

  .manual-sell-wrap {
    padding-top: 28px;
    div {
      padding-top: 20px;
    }
  }
  .submit-wrap {
    margin-top: 48px;
    button {
      width: 100%;
    }
  }

  .checkbox-wrap {
    padding-top: 24px;
    .hint {
      padding-top: 15px;
    }
  }

  .gf-free {
    margin: 24px 0;
    display: flex;
    flex-direction: column;
    text-align: center;

    .value {
      color: #f7931e;
      font-size: 23px;
      font-weight: bold;
    }
    .text {
      font-size: 12px;
      color: #3f3d56;
    }
  }
`;

export const ErrorWrapSC = styled.div`
  margin-top: 24px;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: ${rgba(COLOR_RED, 0.1)};
  p {
    &:last-child {
      line-height: 1.25;
    }
  }
`;

export const ErrorText = styled(SmallText)`
  padding: 6px 0;
  color: ${COLOR_RED};
`;
